import {createSelector} from 'reselect';

export const getToastState = (state) => state.toastState;
export const getMainToast = createSelector([getToastState], (toastState) => {
  const {show, variant, title, content, timeout, placement, id} = toastState;
  return {
    show,
    variant,
    title,
    content,
    timeout,
    placement,
    id,
  };
});
